import { render } from "./SideMenuStart.vue?vue&type=template&id=a03b93aa"
import script from "./SideMenuStart.vue?vue&type=script&lang=js"
export * from "./SideMenuStart.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fredde/programvara/boove.se/w3.boove.se/w3.boove.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__